import { defineComponent, nextTick } from 'vue';
import { shortkeyStatusbar } from '@/mixins/common/shortkeyStatusbar';
import { mixinSuper } from '@/mixins/common/mixinSuper';
import { ModuleLayout, ModuleContext, ModuleDbOption, ModuleDiCacheConfig } from '@/stores/moduleConst';
import { mapState, mapActions, mapGetters } from 'vuex';
import commonFn from '@/commons/commonFunction';
import popupUtil from '@/commons/popupUtil';
import IndexedDB from '@/commons/indexedDB';
import msValidate from '@/components/validate/MsValidate.vue';
import api from '@/apis/report/staticReportPrintAPI';
import { showError } from '@/commons/globalMessage';
import { permission } from '@/mixins/common/permission';
import { collectionMonitor } from '@/setup/utilities/monitor';
import reportSettingAPI from '@/apis/report/voucherReportPrintAPI';
import reportDesignApi from '@/apis/report/reportDesignApi.js';
import _ from 'lodash';
import baseBrowserTitlePage from '@/views/base/baseBrowserTitlePage';

export default defineComponent({
  extends: baseBrowserTitlePage,
  name: 'BaseReportParam',
  mixins: [shortkeyStatusbar, mixinSuper, permission],
  components: {
    msValidate,
  },
  data() {
    var defaultPageSize = this.$store?.state?.dbOption?.dbOptions?.PageSize;
    return {
      /**
       * Mã màn hình hiện tại
       */
      screenCode: '',
      /**
       * Model lưu trữ param
       */
      model: {},

      /**
       *
       * refname control hiển thị dữ liệu: grid/tree
       */
      viewRef: 'viewList',

      /**
       * Các thông tin cấu hình trên grid
       *
       */
      gridInfo: {
        selected: [],
        /**
         * Số lượng bản ghi trên 1 trang
         */
        pageSize: defaultPageSize ?? 20,
      },

      /**
       * Tách riêng request lấy summary ra khỏi hàm lấy paging data
       */ splitLoadRequest: true,

      formNameReport: 'StaticReportPrintPreview', // Tên form mặc định show khi in báo cáo,
      /**
       * Lưu thông tin của chứng từ đã in
       * tbngoc 21.02.2023
       */
      reportConfigPrints: [],
      /**
       * Hiển thị hướng dẫn
       */
      showStep: false,
    };
  },
  computed: {
    /**
     * Đối tượng hiển thị grid/view
     */
    grid() {
      return this.$refs[this.viewRef];
    },
    /**
     * Chọn nhiều bản ghi
     */
    multiSelected() {
      return this.gridInfo.selected?.length > 1;
    },
    ...mapGetters({
      /**
       * Ngôn ngữ hiện tại
       */
      Culture: ModuleContext + '/Culture',
      postedDate: ModuleContext + '/PostedDate',
    }),
    ...mapGetters(ModuleContext, ['Context']),
    /**
     * Đối tượng state của store
     */
    storeState() {
      return this.$store.state[this.module];
    },
    /**
     * Dữ liệu hiển thị
     */
    empty() {
      return this.storeState.empty;
    },
    /**
     * Dữ liệu hiển thị
     */
    items() {
      return this.storeState.items;
    },
    /**
     * loading
     */
    loading() {
      return this.storeState.loading;
    },
    /**
     * Tổng số
     */
    total() {
      return this.storeState.total;
    },
    /**
     * Summary của grid
     */
    summary() {
      return this.storeState.summary;
    },
    /**
     * loading summary
     */
    loadingSummary() {
      return this.storeState.loadingSummary;
    },

    /**
     * Lấy dữ liệu db Option
     */
    dbOptions() {
      return this.$store?.state?.dbOption?.dbOptions;
    },
  },
  created() {
    const me = this;
    this._gridEvent = {
      loadData: me.loadData,
      changePageSize: me.gridChangePageSize,
      filter: me.reload,
      rowDbClick: me.onRowDbClick,
    };
    this._indexDb = new IndexedDB();
  },
  mounted() {
    const me = this;
    window._listReport = this; // TODO: Trong code không dùng cái này (chỉ dùng để debug)
    // Modified by NNKiem 15/11/2023 sửa lại luồng khi lấy dữ liệu param từ storage trước sau đó mới load lại dữ liệu (tránh gọi 2 lần PBI 396806).
    me.show()
      .catch(ex => console.log(ex))
      .finally(() => {
        this.initLayout();
      });

    this.addObserveControl();
  },
  watch: {
    'gridInfo.pageSize'(newVal, oldVal) {
      const me = this;

      if (newVal !== oldVal) {
        //chuyển paging bar về trang đầu
        if (me.grid && typeof me.grid.setPage === 'function') {
          me.grid.setPage(1);
        } else {
          let param = me.lastParam || {
            skip: 0,
            take: me['gridInfo.pageSize'],
          };

          me.loadData(param);
        }
      }
    },
  },
  methods: {
    ...mapActions({
      loadApplyLayout: ModuleLayout + '/loadApply',
    }),
    /**
     * Đẩy dữ liệu lên monitor
     * @param {*} command
     */
    pushTrans(command, isVoucher = false) {
      const { pushTrans } = collectionMonitor();
      var screenName = '',
        screenCode = '',
        module = '';
      if (this._report && this.screenCode == '') {
        var reportID = isVoucher ? this._report.report_id : this._report.reportId;
        if (reportID) {
          this.screenCode = reportID.replace(
            /!|@|%|\^|\*|\(|\)|\+|\=|\<|\>|\?|\/|,|\.|\:|\;|\'|\"|\&|\#|\[|\]|~|\$|_|`|-|{|}|\||\\/g,
            '',
          ); // Code không để ký tự đặc biệt
        }
        screenName = isVoucher ? this._report.report_name : this._report.reportName;
        module = this._report.module;
        screenCode = isVoucher ? (module ? `${module}.${this.screenCode}` : this.screenCode) : this.screenCode;
      }
      pushTrans(command, screenName, screenCode);
    },
    /**
     * Khởi tạo observe control
     * NCPHUOC 20/04/2022
     * .ms-validate được thêm vào root khi khai báo rules
     */
    addObserveControl() {
      if (!this._observeControls) {
        this._observeControls = [];
        const $el = this.$el;
        const $controls = $el.querySelectorAll('.ms-validate');
        if ($controls && $controls.length > 0) {
          $controls.forEach(item => {
            if (typeof item.getVueInstance === 'function') {
              this._observeControls.push(item.getVueInstance());
            }
          });
        }
      }
    },
    beforeOpen(e) {
      const me = this;
      me._popup = me.$vfm.dynamicModals[me.$vfm.dynamicModals.length - 1];
      if (e.ref.params._rawValue) {
        this._formName = e.ref.params._rawValue.name;
        this._report = e.ref.params._rawValue;
        this._formParam = e.ref.params._rawValue;

        // nvtoan2 19/12/2023: Tạo ra 1 cái key để xác định reload báo cáo tại vị trí
        // Cái số nhân kia là số linh tinh thôi, chọn số nào cũng dc
        this._report.KeyReload = Math.floor(Math.random() * 110720) + '';
        // Gán posteddate để dùng trên báo cáo
        this._report.PostedDate = this.postedDate;
      }
    },
    beforeClose() {
      delete this._formName;
      delete this._report;
      delete this._formParam;
      this.hide();
      commonFn.closePrintIframe();
    },

    /**
     * Đóng form
     */
    hide() {
      const me = this;
      me._suppendClose = true;

      try {
        me._popup.value = false;
      } catch (error) {
        console.log(error);
      }

      me.$nextTick(() => {
        me._suppendClose = true;
        delete me._popup;
      });
    },

    /**
     * Thay đổi pagesize
     */
    gridChangePageSize(value) {
      this.gridInfo.pageSize = value;
    },

    /**
     * Thực hiện load data
     * HTHIEP 04.05.2022
     */
    async show() {
      //lấy dữ liệu
      const data = await this.loadRecentData(this._formName);
      // focus control nhập liệu đầu tiên
      this.focusFirstControl();

      //Cập nhật dữ liệu vào model
      this.bindData(data);
    },

    /**
     * focus control nhập liệu đầu tiên
     */
    focusFirstControl() {
      setTimeout(() => {
        this.$nextTick(() => {
          this.$ms.commonFn.focusFirstControlInput(this.$el);
        });
      }, 300);
    },
    /**
     * Lấy tham số báo cáo lần gần nhất
     * @param {*} formName
     * @returns
     */
    async loadRecentData(formName) {
      if (formName) {
        try {
          const recentData = await this._indexDb.get(formName);
          if (recentData) {
            //hmduc2 22.09.2023: Sửa lỗi luôn checkAll Mục, nếu checkAll ở lần in trước đó.
            recentData.SelectedAll = false;
            return recentData;
          }
        } catch (error) {
          console.log(error);
          //init lỗi
        }
      }
      return this.model;
    },

    /**
     * Bind dữ liệu cho form
     */
    bindData(data) {
      const me = this;
      Object.assign(me.model, data);
      me.beforeBindData();
    },

    beforeBindData() { },
    /**
     * Hàm xử lý action dbClickRow
     * NNLINH 04.07.2022
     */
    onRowDbClick(row) { },

    initLayout() {
      const me = this;
      if (me.layoutTag) {
        let layout = me.getCacheLayoutTemplate();

        if (!layout || process.env.NODE_ENV === 'development') {
          me.loadApplyLayout(me.layoutTag).then(layout => {
            //set cache
            me.setCacheLayoutTemplate(layout);

            me.applyLayout(layout);
          });
        } else {
          me.applyLayout(layout);
        }
      } else {
        me.$nextTick(() => {
          me.reload();
        });
      }
    },

    /**
     * lấy mẫu layout từ cache
     */
    getCacheLayoutTemplate() {
      const me = this;
      try {
        let layoutTemplate;
        let cacheKey = me.getCacheLayoutTemplateKey();
        if (cacheKey) {
          // let cacheData = await me.$ms.indexedDB.get(cacheKey);
          let cacheData = me.$ms.commonFn.getSessionStorage(cacheKey);
          if (cacheData) {
            layoutTemplate = JSON.parse(cacheData);
          }
        }
        return layoutTemplate;
      } catch (ex) {
        console.error(ex);
      }
      return null;
    },
    /**
     * lưu cache mẫu layout
     */
    setCacheLayoutTemplate(layout) {
      const me = this;
      let cacheKey = me.getCacheLayoutTemplateKey();
      if (cacheKey) {
        // let cacheData = await me.$ms.indexedDB.get(cacheKey);
        me.$ms.commonFn.setSessionStorage(cacheKey, JSON.stringify(layout));
      }
    },
    /**
     * lấy cache key mẫu layout
     */
    getCacheLayoutTemplateKey() {
      const me = this;
      let cacheKey = '';
      if (me.Context && me.Context.UserID && me.layoutTag) {
        cacheKey = 'LayoutTemplate_{0}_{1}'.format(me.layoutTag, me.Context.UserID);
      }
      return cacheKey;
    },
    /**
     * Render mẫu
     */
    applyLayout(layout) {
      const me = this;

      me.layout = me.convertToLayoutTemplete(layout);
      let columns = me.getLayoutColumn(layout, me.layoutTag);

      // custom column theo dbOption
      if (me.dbOptions) {
        me.applyColumnByDbOption(columns, me.dbOptions);
      }
      me.customColumns(columns);

      me.grid.initColumns(columns);

      //load dữ liệu lần đầu
      me.$nextTick(() => {
        me.reload();
      });
    },
    /**
     * Thêm hàm xử lý filter
     * @param {*} columns 
     */
    customColumns(columns) { },

    /**
     * Hàm custom hiển thị layout theo dbOption
     * lttuan1 - 26.9.2022
     */
    applyColumnByDbOption(columns, dbOptions) {
      let me = this;
      columns.forEach(item => {
        switch (item.dataField) {
          // mã dự phòng
          case 'budget_provide_code':
            if (!dbOptions.IsDetailbyBudgetProvidence) {
              item.visible = false;
            }
            break;
          // ctmt, dự án
          case 'project_code':
            if (!dbOptions.UseProjectManagement) {
              item.visible = false;
            }
            break;
          // tiết tiểu mục
          case 'budget_detail_item_code':
            if (!dbOptions.AccountingBudgetDetailItemCode) {
              item.visible = false;
            }
            break;
          // Danh mục dự án: hoạt động, khoản chi
          case 'project_activity_id':
          case 'project_expense_id':
          case 'project_expense_code':
            if (!dbOptions.IsProjectDetailbyActivityAndExpense || !dbOptions.UseProjectManagement) {
              item.visible = false;
            }
            break;
          // đề tài
          case 'topic_code':
            if (!dbOptions.UseTopicManagement) {
              item.visible = false;
            }
            break;
          // hợp đồng
          case 'contract_no':
            if (!dbOptions.UseContract) {
              item.visible = false;
            }
            break;
          // Nhiệm vụ
          case 'task_code':
            if (!dbOptions.UseTask) {
              item.visible = false;
            }
            break;
          // Nguồn năm trước
          case 'is_source_before_year':
            if (!dbOptions.UseSourceBeforeYear) {
              item.visible = false;
            }
            break;
          // Cơ cấu vốn
          case 'fund_structure_name':
            if (!dbOptions.UseInvestorAccounting) {
              item.visible = false;
            }
            break;
          default:
            me.applyColumnByDbOptionCustom(item, dbOptions);
            break;
        }
      });
    },

    /**
     * Custom các cột có dataField khác theo dbOptions
     */
    applyColumnByDbOptionCustom(columns, dbOptions) { },

    convertToLayoutTemplete(layout) {
      let layoutTemplete = {};
      if (layout) {
        layoutTemplete.code = layout.tag;
        layoutTemplete.is_system = layout.is_system;
        layoutTemplete.config = layout.config;
      }
      return Object.assign({}, layoutTemplete);
    },

    /**
     * Lấy thông tin column render từ thông tin của mẫu
     */
    getLayoutColumn(layout, tag) {
      if (layout != undefined) {
        const me = this;
        let columns = JSON.parse(layout.config);

        //nếu là mẫu mặc định và ngôn ngữ khác tiếng việt -> cập nhật caption/title theo ngôn ngữ
        if (layout.is_system) {
          me.localizationColumn(columns, tag);
        }
        //nnlam: orderby lại theo sort_order và lock.
        columns = _(columns)
          .chain()
          .sortBy('sort_order')
          .sortBy(function (column) {
            return !column.lock;
          })
          .value();
        return columns;
      }
    },
    /**
     * Xử lý ngôn ngữ cho caption và title của column
     */
    localizationColumn(columns, tag) {
      const me = this,
        culture = me.Culture;

      //nếu là mẫu mặc định và ngôn ngữ khác tiếng việt -> cập nhật caption/title theo ngôn ngữ
      if (culture !== 'vi') {
        let fn = function (column, field, key) {
          let text = me.$ms.commonFn.getColumnText(field, tag);
          if (typeof text !== 'undefined') {
            column[field] = text;
          }
        };

        for (let i = 0; i < columns.length; i++) {
          let col = columns[i];
          fn(col, 'caption', col.dataField);
          fn(col, 'title', col.dataField + 'Title');
        }
      }
    },

    /**
     * Load lại dữ liệu
     */
    reload() {
      const me = this;
      //chuyển paging bar về trang đầu
      if (me.grid && typeof me.grid.setPage === 'function') {
        me.grid.setPage(1);
      }

      //xóa tham số cũ để reload
      delete me.lastParam;
      me.refresh();
    },
    /**
     * Load lại dữ liệu
     */
    refresh() {
      const me = this;
      let param = me.lastParam || {
        skip: 0,
        take: me.gridInfo.pageSize,
      };

      const cacheConfigModule = this.$store.getters[`${ModuleDiCacheConfig}/items`];
      if (Array.isArray(cacheConfigModule)) {
        const cacheConfig = cacheConfigModule.find(x => x.module === this.module);
        if (cacheConfig) {
          return;
        }
      }

      me.loadData(param);
      //load summary
      if (me.splitLoadRequest) {
        me.loadDataSumary(param);
      }
    },

    /**
     * Load summary cho grid danh sách
     */
    loadDataSumary(payload) {
      const me = this;

      //tham số chỗ này đã qua hàm load data dc xử lý rồi
      let param = {};
      for (let i in payload) {
        switch (i) {
          case 'skip':
          case 'take':
          case 'sort':
          case 'ignoreSummary':
            //bỏ qua
            break;
          // case "columns":
          //   //TODO chỗ này sẽ chế lại chỉ lấy các cột có sum thôi
          //   break;
          default:
            param[i] = payload[i];
            break;
        }
      }
      //fix chỉ đọc summary
      param.type = me.$ms.constant.PagingType.Summary;

      //xử lý cột summary
      if (me.grid && Array.isArray(me.grid.columnx)) {
        var sumColumns = [];
        me.grid.columnx.forEach(col => {
          if (col.summaryType) {
            sumColumns.push([col.dataField, col.summaryType].join(':'));
          }
        });

        if (sumColumns.length > 0) {
          param.sumColumns = sumColumns.join(',');
        }
      }

      /**
       * Gọi request load data
       */
      me.requestLoadDataSummary(param);
    },

    /**
     * Gọi request load summary
     */
    requestLoadDataSummary(payload) {
      const me = this;
      if (me.grid && !me.grid.isGridTree) {
        me.$store.dispatch(`${me.module}/loadSummary`, payload);
      }
    },

    /**
     * Load dữ liệu grid
     */
    loadData(payload) {
      const me = this;
      if (me.grid) {
        //nếu là trang đầu build lại tham số, các trang tiếp theo dùng lastParam và chỉ đổi skip
        if (!payload.skip) {
          //xử lý các tham số khác
          me.processLoadParameter(payload);

          //chuẩn hóa tham số truyền lên server
          me.nomalizeLoadParameter(payload);
        } else {
          for (let i in me.lastParam) {
            switch (i) {
              case 'skip':
                //bỏ qua
                break;
              default:
                payload[i] = me.lastParam[i];
                break;
            }
          }
        }

        //cache lại tham số để dùng cho xuất khẩu và restore data cho lần sau quay lại
        me.lastParam = payload;

        if (me.splitLoadRequest) {
          //fix chỉ đọc data
          payload.type = me.$ms.constant.PagingType.PageData;
        }

        /**
         * Gọi request load data
         */
        me.requestLoadData(payload);
      }
    },

    /**
     * Xử lý điều kiện lọc với nội dung tìm kiếm
     */
    processLoadParameterSearch(payload) {
      const me = this,
        fields = me.searchFields,
        op = me.$ms.constant.FilterOperator.Contains,
        text = (me.searchText || '').trim();

      if (text && Array.isArray(fields) && fields.length > 0) {
        let filter = {
          Field: fields[0],
          Operator: op,
          Value: text,
        };
        payload.filter.push(filter);

        if (fields.length > 1) {
          filter.Ors = [];
          for (let i = 1; i < fields.length; i++) {
            filter.Ors.push({
              Field: fields[i],
              Operator: op,
              Value: text,
            });
          }
        }
      }
    },

    /**
     * Xử lý tham số load dữ liệu
     */
    processLoadParameter(payload) {
      const me = this;

      //filter
      payload.filter = [];
      if (me.grid.filterable && typeof me.grid.getFilterHeader === 'function') {
        payload.filter = me.grid.getFilterHeader();
      }

      //search text
      me.processLoadParameterSearch(payload);

      //column
      payload.columns = me.processLoadParameterColumn(payload);

      //tham số load dữ liệu
      payload.condition = me.getConditionParameter();
      // nếu grid có cấu hình sort default thì
      if (me.grid.defaultSort && Array.isArray(me.grid.defaultSort)) {
        let listSort = [];
        me.grid.defaultSort.forEach(item => {
          // nếu có sort custom thì nếu trùng với item nào thì loại item đó ra khỏi listSort để không bị trùng
          if (payload.Sort) {
            if (!payload.Sort.contains(item.sortField)) {
              listSort.push(`${item.sortField} ${item.sortType == me.$ms.constant.SortStatus.desc ? 'DESC' : 'ASC'}`);
            }
          } else {
            listSort.push(`${item.sortField} ${item.sortType == me.$ms.constant.SortStatus.desc ? 'DESC' : 'ASC'}`);
          }
        });
        let sortDefault = listSort.length > 0 ? listSort.join(', ') : '';
        let sortCustom = payload.Sort ? payload.Sort : '';
        if (sortCustom && sortDefault) {
          payload.sort = [sortCustom, sortDefault].join(', ');
        } else if (!sortCustom && sortDefault) {
          payload.sort = sortDefault;
        } else if (sortCustom && !sortDefault) {
          payload.sort = sortCustom;
        } else {
          payload.sort = '';
        }
      }

      me.customPayload(payload);
    },

    /**
     * Custom tham số payload trước khi call api
     */
    customPayload(payload) { },

    /**
     * Custom tham số load dữ liệu
     */
    processLoadParameterColumn(payload) {
      const me = this;
      let columns = me.grid.columnx;
      let cols = [];
      if (columns) {
        for (let i = 0; i < columns.length; i++) {
          let col = columns[i];
          if (col.dataField && cols.indexOf(col.dataField) === -1) {
            cols.push(col.dataField);
          }
        }
      }
      if (me.grid.idField) {
        cols.push(me.grid.idField);
      }

      if (me.grid.isGridTree) {
        if (me.grid.parentIdField && cols.indexOf(me.grid.parentIdField) === -1) {
          cols.push(me.grid.parentIdField);
        }
      }
      if (me.alwayTakeColumns && me.alwayTakeColumns.length != 0) {
        /*
         * Cấu hình lấy thêm các cột được cấu hình luôn lấy dữ liệu trên grid
         * pvduy 19/01/2021
         */
        for (let i = 0; i < me.alwayTakeColumns.length; i++) {
          if (!cols.includes(me.alwayTakeColumns[i])) {
            cols.push(me.alwayTakeColumns[i]);
          }
        }
      }
      return cols;
    },

    /**
     * Lấy điều kiện load dữ liệu
     */
    getConditionParameter() {
      const me = this;
      let param = {};
      if (me.condition) {
        for (let i in me.condition) {
          let value = me.condition[i];
          if (value) {
            //date
            if (typeof value.getFullYear === 'function') {
              //nếu tên thuộc tính có từ Time -> lấy full datetime
              //else chỉ lấy date
              if (i.indexOf('Time') > -1) {
                value = moment(value).format('YYYY-MM-DD hh:mm:ss');
              } else {
                value = moment(value).format('YYYY-MM-DD');
              }
            }
          }
          param[i] = value;
        }
      }
      return param;
    },

    /**
     * Chuẩn hóa lại tham số truyền lên server
     */
    nomalizeLoadParameter(payload) {
      const me = this;
      if (!payload.skip) {
        delete payload.skip;
      }

      if (payload.filter && payload.filter.length > 0) {
        //Clear múi giờ trước khi đẩy lên server
        payload.filter.forEach((item, i) => {
          let value = item.value;
          if (value) {
            if (typeof value.getFullYear === 'function') {
              item.value = me.$ms.commonFn.getMoment(value).format('YYYY-MM-DDTHH:mm:ss');
            }
          }
        });

        payload.filter = JSON.stringify(payload.filter);
      } else {
        delete payload.filter;
      }

      if (payload.condition && Object.keys(payload.condition).length > 0) {
        payload.condition = JSON.stringify(payload.condition);
      } else {
        delete payload.condition;
      }

      if (payload.columns && payload.columns.length > 0) {
        payload.columns = payload.columns.join(',');
      } else {
        delete payload.columns;
      }
    },

    /**
     * Gọi request load dữ liệu
     * Modiffied NNLINH 04.07.2022: thêm handleBeforeBinding
     */
    async requestLoadData(payload) {
      const me = this;
      if (me.grid && me.grid.isGridTree) {
        me.$store.dispatch(`${me.module}/loadTree`, {
          columns: payload.columns,
        });
      } else {
        let data = await me.$store.dispatch(`${me.module}/load`, payload);
        me.handleBeforeBinding(data);
      }
    },

    /**
     * Hàm validate các control input
     * Hàm này sử dụng component ms-validate
     * để bao ngoài vùng được validate
     * @Chú ý:ref của ms-validate phải là validateObserver
     * dtnga3 (25.08.2022)  - lấy về từ baseDetail
     */
    validateComponents() {
      const me = this;
      let controls = me._observeControls.filter(
        x =>
          x.$el.offsetWidth ||
          x.$el.offsetHeight ||
          x.$el.getClientRects().length ||
          /** Xử lý validate control khi ẩn */
          (x.rules && Array.isArray(x.rules) && x.rules?.some(x => x.hide)),
      );
      if (controls.length > 0) {
        const errors = controls.map(x => {
          if (typeof x.validate === 'function') {
            return x.validate();
          }
          return '';
        });
        return !errors.some(x => x);
      }
      return true;
    },

    /**
     * Hàm dùng để focus vào ô lỗi đầu tiên
     * dtnga3 (25.08.2022)  - lấy về từ baseDetail
     * */
    focusFirstError() {
      const me = this;
      const $el = me.$el;
      const firstErrorEl = $el.querySelector('.ms-editor .error input,textarea');
      if (firstErrorEl) {
        firstErrorEl.focus();
      }
    },
    /**
     * Xử lý dữ liệu trước khi bind Data
     */
    handleBeforeBinding(data) { },

    /**
     * lấy thêm tham số ngoài tham số trên form
     */
    getCustomReportParams(reportId) { },

    /**
     * Submit các grid đang edit
     * dtnga3 (04.10.2022)
     */
    submitGridEditor() {
      try {
        const me = this,
          { _gridDetails } = me;
        const submitAction = [];
        if (_gridDetails) {
          for (const key in _gridDetails) {
            //NVTUAN1 01.03.2024: Sử dụng hàm hasOwnProperty không ảnh hưởng bởi PBI 419812
            if (Object.hasOwnProperty.call(_gridDetails, key)) {
              const keyRef = _gridDetails[key];
              const $gridRef = me.$refs[keyRef];
              if ($gridRef && typeof $gridRef.submitEditor === 'function') {
                submitAction.push($gridRef.submitEditor());
              }
            }
          }
        }

        return Promise.all(submitAction);
      } catch (error) {
        console.log(error);
      }
    },
    reportSettingApply() {
      const me = this;
      // Lấy thông tin tùy chọn in
      const formParam = this._formParam;
      if (this.model) {
        this.model.$ListRefID = formParam?.list_ref_id || formParam?.ref_id;
        this.model.$RefType = formParam?.ref_type;
        this.model.ViewReceiptFullAmount = formParam?.view_receipt_full_amount;
        this.model.PrintInfomationReceiptUnit = formParam?.print_information_receipt_unit;
        this.model.PrintSystemDate = formParam?.print_system_date;
        this.model.PrintVourcherDate = formParam?.print_voucher_date;
        this.model.PrintPreview = formParam?.print_voucher_preview;
        this.model.AllowBatchPrinting = formParam?.allow_batch_printing;
        this.model.DateTimeReport = formParam?.print_system_date ? me.postedDate : null;
        this.model.$PrintedType = formParam?.printed_type || 2;
        this.model.$OrderBy = formParam?.order_by || '';
      }
    },
    /**
     * Xử lý action trên form
     * HTHIEP 04.05.2022
     * @param {*} command
     */
    commandClick(command) {
      const me = this;
      switch (command) {
        case this.$ms.constant.Command.Ok:
          // validate control
          if (!me.validateComponents()) {
            nextTick(() => {
              me.focusFirstError();
            });
            return;
          }

          // Validate các nghiệp vụ khác trước khi in
          if (!me.validateBeforePrintReport()) {
            return;
          }
          this.printReport();
          break;
      }
      this.pushTrans(command);
      // mcp tùy chọn in
      if(me.isReportSetting){
        this.screenCode = '';
        me.pushTrans(me.$ms.constant.Command.ReportSetting);
      }
    },
    /**
     * Custom lại API
     * @param {*} paramAPI
     * @returns API
     * dqdat1 24.04.2023
     */
    customAPI(paramAPI) {
      return paramAPI;
    },

    /**
     * Tách hàm In báo cáo để truyền option cho khi in cả bìa.
     * HMDUC2 29/01/2024
     */
    printReport() {
      const me = this;
      commonFn.mask();
      me.beforePrintReport();
      //Lưu lại params vào index db => load lại lần sau
      this._indexDb.set(this._formName, this.model);
      //Lưu param trên server thực hiện load preview report
      //gọi lưu tham số và mở ra preview
      const param = { ...this._report, ...{ DataParam: this.model } };

      // lấy thêm tham số ngoài tham số trên form
      const customParams = this.getCustomReportParams(this._report.report_id);

      // lấy thêm backRouter (áp dụng cho báo cáo có Drill Down in ở nhiều màn hình)
      this._report.backRouter = me._formParam?.backRouter || '/report';
      param.DataParam.BackRouter = this._report.backRouter
        .split('/')
        .filter(x => x != '')
        .join('-');

      if (customParams) {
        param.DataParam = { ...param.DataParam, ...customParams };
      }
      
      // Lúc nào cũng check xem có in bìa không
      param.DataParam.IsPrintReportCover = me.isPrintCoverReport();
      // HMDUC2: Nếu như in bìa thì đẩy thêm tham số ngày hạch toán và tham số có in bìa hay không - PBI401517
      if (me.isPrintCoverReport()) {
        param.DataParam.DateTimeCoverReport = this.postedDate;
      }

      me.handleParamReport(param);
      this.customAPI(api)
        .saveParamter(param)
        .then(async result => {
          if (me.isPrintCoverReport() && this._report.isRefresh != true) {
            this.editReportCover({ item: this?._report, token: this?.token, key: result, apiPrint: api});
          } else {
            this.showPrintPreview(result,api, param);
            // HMDUC2: Gán lại bằng false để mở form sửa bìa nếu tiếp tục in báo cáo.
            this._report.isRefresh = false;
          }
        })
        .catch(err => {
          commonFn.unmask();
          console.log(err);
          showError(err);
        });
    },

    /**
     * Tách hàm show màn hình preview để truyền option khi mở form sửa bìa phục vụ in báo cáo
     * @param {*} apiPrint api in báo cáo
     * @param {*} key key được trả về từ BE để in  
     * HMDuc2: 11/03/2024
     */
    async showPrintPreview(key, apiPrint, param) {
      commonFn.mask();
      const me = this;
      if (this._report.print_voucher_preview === false) {
        commonFn.printPreviewReport(this._report, result, apiPrint);
      } else {
        await popupUtil.hide(me.formNameReport);
        //không ẩn mask để cho popup preview gọi ẩn đi
        popupUtil.show(me.formNameReport, {
          report: this._report,
          param: param,
          key: key,
          reportParam: this.model,
          isPrintCover: this.isPrintCoverReport(),
          // options: {
          //   close: () => {
          //     this.beforeClose();
          //   }
          // }
        });
        popupUtil.hide(me._formName);
        // let link = api.getPrintLink(result);
        // window.open(link);
        me.handleAfterPrint();
      }
    },

    /**
     * Mở form edit bìa
     * @param {*} item report
     * @param {*} token token 
     * @param {*} key key được trả về từ BE 
     * @param {*} apiPrint api để in báo cáo từ màn sửa bìa
     * HMDUC2 29/01/2024
     */
    editReportCover({ item, token, key, apiPrint}) {
      popupUtil.show('CoverReportDesigner', {
        designLink: reportDesignApi.getDesignLink(
          commonFn.removeFileExtension(item.report_file),
          item.reportId,
          token
        ),
        reportName: item.reportName,
        report_file: item.report_file,
        key: key,
        typePrint: 0,
        isAllowEditTable: true,
        is_batch_printing: false,
        reportId: item.reportId,
        refreshReport: "",
        title_as_report_name: "title_as_report_name",
        reportCoverCommon : item.reportCoverCommon,
        param: this.model,
        options: {
          print: () => {
            this.showPrintPreview(key, apiPrint);
          },
        },
      });
    },

    /**
     * Có in bìa báo cáo hay không lấy từ dbOption và config env
     * HMDUC2 23/02/2024
     */
    isPrintCoverReport() {
      let dbOptions = { ...this.$store.state.dbOption.dbOptions };
      var isPrintCover = dbOptions?.PrintReportCover && window._newPrintCover?.includes(this?._formParam?.reportId)
      return isPrintCover;
    },

    /**
     * xử lý lại param
     * ptthuy2 14.06.2023
     */
    handleParamReport(param) { },

    /**
     * Xử lý sau khi xem báo cáo
     * dqdat1 13.06.2023
     */
    handleAfterPrint() { },

    beforePrintReport() {
      const me = this;
      // Thực hiện cập nhật thông tin đã in
      commonFn.savePrintMultipleReportsConfigPrint(this._report, this._report.printItemInfos ?? this._report.selectedVoucher, this._report);
      me.reportSettingApply();
    },

    /**
     * NVTUAN1 28.10.2022
     * Validate các nghiệp vụ tùy theo từng báo cáo trước khi in báo cáo
     * => DEV override lại hàm này để xử lý validate
     * @returns true or false
     */
    validateBeforePrintReport() {
      return true;
    },

    /**
     * Xem
     * */
    view(record, formName) {
      const me = this;

      //kiểm tra phân quyền
      me.checkActionPermissionAlert(me.$ms.constant.Permission.View);

      // lấy tên form detail để show
      // dtnga3 (14.07.2022) Nếu bên ngoài có truyền vào tên form detail thì sẽ thực hiện show form đó
      let formDetailName = formName;

      let param = me.getDetailParameter(formDetailName, this.$ms.constant.FormState.View, record);

      me.showDetail(formDetailName, param, {
        submit: function (saveResult, saveParam) {
          if (saveResult.Success) {
            me.afterSaveView(record, saveResult, saveParam);
          }
        },
      });
    },
    /**
     * @private
     * Lấy tham số khi mở form chi tiết
     * */
    getDetailParameter(formName, mode, defaultData) {
      const me = this;

      let param = {
        data: defaultData || null,
      };

      switch (mode) {
        case me.$ms.constant.FormState.Duplicate:
        case me.$ms.constant.FormState.Edit:
        case me.$ms.constant.FormState.View:
          if (me.$store.state[me.module]._config.field.key) {
            param.id = defaultData[me.$store.state[me.module]._config.field.key];
          }
          break;
      }

      param.mode = mode;

      me.customDetailParam(param);

      return param;
    },
    customDetailParam(param) { },
    /**
     * Hàm show các popup theo tên lấy đường dẫn từ hàm getPopupomponent
     * @param name tên của component
     * Created by LTDAT(17.06.2020)
     */
    showDetail(name, data, option) {
      const me = this;

      if (me.isCacheParam) {
        me._indexDb = me._indexDb || new IndexedDB();
        let key = [name, data.id || ''].filter(x => x).join('_');
        let save = Object.assign({}, data, {
          module: me.module,
          currentPath: location.pathname,
        });
        me._indexDb.set(key, save);
      }

      popupUtil.show(name, data, me.getPopupOption(name, option));
    },
    getPopupOption(name, option) {
      const me = this;
      return {
        submit: me.submitDetailCallback,
      };
    },

    /**
     * Hướng dẫn
     */
    guide(e, disable) {
      if (!disable) {
        this.showStep = true;
      }
    },

    /**
     * Link help
     */
    linkHelp(code, type) {
      type = type || 'mimosa';
      return window._helpLink[type] + window._misaHelp[code];
    },

    /**
     * Hiển thị form chi tiết khi click vào ô (nếu có config linkedForm)
     * HQMINH 18.07.2022
     */
    viewLinkedForm(col, dataRow) {
      const me = this;

      // Lấy tên form tùy theo đặc tính ref_type từng bản ghi(Lấy động)
      let formName = me.getFormDetailName(dataRow);

      if (formName) {
        me.viewIncurredData(dataRow, formName);
      }
    },

    /**
     * Lấy tên form chi tiết theo ref_type
     * @param {*} record  dữ liệu dòng trên grid
     * @returns tên form chi tiết
     * HQMINH 18.07.2022
     */
    getFormDetailName(record) {
      const me = this;
      // lấy tên form detail để show
      let formDetailName = '';

      if (record && record.ref_type) {
        Object.keys(me.$ms.constant.RefTypeMapperDetailName).forEach(item => {
          if (
            (Array.isArray(me.$ms.constant.RefTypeMapperDetailName[item]) &&
              me.$ms.constant.RefTypeMapperDetailName[item].find(x => x == record['ref_type'])) ||
            (Number.isInteger(me.$ms.constant.RefTypeMapperDetailName[item]) &&
              me.$ms.constant.RefTypeMapperDetailName[item] == record['ref_type'])
          ) {
            formDetailName = item;
          }
        });
      } else {
        formDetailName = me.formDetailName;
      }

      if (!formDetailName) {
        console.error('Chưa khai báo tên form chi tiết ở RefTypeMapperDetailName.js');
      }

      return formDetailName;
    },

    /**
     * Xem chứng từ phát sinh
     * HQMINH 18.07.2022
     * Modified by NVTUAN1 12.05.2023: Refactor code để truyền đúng tham số cho popup
     * */
    viewIncurredData(record, formName) {
      const me = this;
      //kiểm tra phân quyền
      me.checkActionPermissionAlert(me.$ms.constant.Permission.View);

      // lấy tham số cho form detail
      let params = me.getDetailParameterIncurredData(formName, this.$ms.constant.FormState.View, record);

      me.customParameterIncurredData(params);
      //Thêm callback function khi click xem chứng từ
      params.options.callbackFnIncurred = me.callbackFnIncurred;

      //Show chi tiết chứng từ phát sinh
      popupUtil.show(formName, params);
    },
    /**
     * Custom param
     */
    customParameterIncurredData(params) { },
    /**
     * Lấy tham số khi mở form chi tiết phát sinh dữ liệu
     * HQMINH 18.07.2022
     * */
    getDetailParameterIncurredData(formName, mode, defaultData) {
      const me = this;

      let param = {
        data: defaultData || null,
      };

      switch (mode) {
        case me.$ms.constant.FormState.Duplicate:
        case me.$ms.constant.FormState.Edit:
        case me.$ms.constant.FormState.View:
          param.id = defaultData?.ref_id;
          break;
      }

      param.mode = mode;
      param.options = {};

      return param;
    },
  },
});
